import { useEffect, useRef } from 'react';
import { socket } from '../services/socket';

export const useTeacherSocket = (onUpdate) => {
  const onUpdateRef = useRef(onUpdate);

  useEffect(() => {
    onUpdateRef.current = onUpdate;
  }, [onUpdate]);

  useEffect(() => {
    const handler = (data) => {
      if (onUpdateRef.current) {
        onUpdateRef.current(data);
      }
    };

    socket.on('teacher:updated', handler);

    return () => {
      socket.off('teacher:updated', handler);
    };
  }, []);
};